import React from 'react';
import withSEO from 'Hoc/withSEO';
import Page5XXV3 from './5XXV3';

const Page504V3: React.FC = () => (
  <Page5XXV3
    title="Gateway Timeout"
    text="Request to upstream server has timed out. Please try again."
  />
);

export default withSEO({ title: 'Service Timeout' })(Page504V3);
